// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"lcphwleV2UUmO0vVYd760","highlighter":"_2q9GqSLpRhzOP8znUh6OMS"};